namespace Solovis.Reports.DataSetHelpers {

    /**
     * HoldingsNetExposureByTagIndex will index values returned from the /Solovis/Exposure/HoldingsExposureByTag data source.
     */
    export class HoldingsNetExposureByTagIndex {

        public modelEnv: InvData.ModelEnvironment;
        public tagSetId: number;
        public tagSet: InvData.Models.TagSet;
        public exposureType: string;

        public _entityIdToTagValuesMap;
        public _weightedTagNetTotals;
        public _tagBreakoutHelper;

        constructor(options) {
            this.modelEnv = options.modelEnv ? options.modelEnv : null;
            this.tagSetId = options.tagSetId ? options.tagSetId : null;

            if (this.modelEnv && this.tagSetId) {
                this.tagSet = this.modelEnv.tagSets.tryGetById(this.tagSetId);
            }
            else {
                throw "tagSet could not be found";
            }

            // exposureType can be MarketValue, Notional, or Delta-Adjusted.
            this.exposureType = options.exposureType ? options.exposureType : "MarketValue";

            this._entityIdToTagValuesMap = {};

            // tagId to net weighted total for that tag.
            this._weightedTagNetTotals = {};

            // _tagBreakoutHelper will provide hierarchical grouping of tags that are represented.

            this._tagBreakoutHelper = new Solovis.Reports.DataSetHelpers.TagBreakoutHelper({
                tagSet: this.tagSet
            });
        }


        /**
         * Merge in values from /Solovis/Exposure/HoldingsExposureByTag data source.
         * @param dataSet
         */
        public mergeValues(dataSet): void {
            var self = this;

            if (dataSet._notLoaded) {
                // The data set is empty.
                return;
            }

            var exposureType = this.exposureType;
            var netExposureSummary = dataSet.exposureSummary;

            var overallValue = netExposureSummary.overallValue;

            $(netExposureSummary.exposuresByEntity).each(function (i, netExposureForEntity: any) {
                var entityId = netExposureForEntity.entityId;

                var entityAmount;
                switch (exposureType) {
                    case "MarketValue": entityAmount = netExposureForEntity.marketValue; break;
                    case "Notional": entityAmount = netExposureForEntity.notional; break;
                    case "DeltaAdjusted": entityAmount = netExposureForEntity.deltaAdjusted; break;
                    default: throw "Unexpected exposureType: " + exposureType;
                }

                var entityWeight = overallValue ? (entityAmount / overallValue) : 0;

                $(netExposureForEntity.exposures).each(function (j, netExposureForTag: any) {
                    var tagId = netExposureForTag.tagId;

                    var entityTagAmount;
                    switch (exposureType) {
                        case "MarketValue": entityTagAmount = netExposureForTag.marketValue; break;
                        case "Notional": entityTagAmount = netExposureForTag.notional; break;
                        case "DeltaAdjusted": entityTagAmount = netExposureForTag.deltaAdjusted; break;
                        default: throw "Unexpected exposureType: " + exposureType;
                    }

                    var tagValuesMap;
                    if (self._entityIdToTagValuesMap[entityId]) {
                        tagValuesMap = self._entityIdToTagValuesMap[entityId];
                    }
                    else {
                        tagValuesMap = {};
                        self._entityIdToTagValuesMap[entityId] = tagValuesMap;
                    }

                    var value;
                    if (tagValuesMap[tagId]) {
                        value = tagValuesMap[tagId];
                    }
                    else {
                        value = { net: 0 };
                        tagValuesMap[tagId] = value;
                    }

                    var entityTagNetPercentage = 0;
                    if (entityAmount != 0) {
                        entityTagNetPercentage = entityTagAmount / entityAmount;
                    }

                    value.net += entityTagNetPercentage;

                    var weightedTagNet = entityTagNetPercentage * entityWeight;
                    var previousWeightedTagNetTotal = self._weightedTagNetTotals[tagId];
                    self._weightedTagNetTotals[tagId] = Solovis.isNotNull(previousWeightedTagNetTotal) ? (previousWeightedTagNetTotal + weightedTagNet) : weightedTagNet;

                    self._tagBreakoutHelper.reportTagIdInUse(tagId);
                });
            });
        }


        public doesEntityIdHaveData(entityId: number) {
            if (this._entityIdToTagValuesMap[entityId]) {
                return true;
            }
            else {
                return false;
            }
        }

        /**
         * For a specific tag, return the total weight to that specific tag as percentage of overall value.
         * @param tagId
         */
        public getWeightedTagNet(tagId: number) {
            var weightedTagNet = this._weightedTagNetTotals[tagId];
            if (Solovis.isNotNull(weightedTagNet)) {
                return weightedTagNet;
            }

            return 0;
        }

        /**
         * Retrieve net exposure percentage for entity relative to the value of entity held.
         * @param entityId
         * @param tagId
         */
        public getNet(entityId: number, tagId: number): number {
            if (this._entityIdToTagValuesMap[entityId]) {
                var tagValuesMap = this._entityIdToTagValuesMap[entityId];

                if (tagValuesMap[tagId]) {
                    var value = tagValuesMap[tagId];
                    return value.net;
                }
            }

            return 0;
        }

        /**
         * getBranchNet will retrieve the sum of all net values within the tag branch as percentage relative to
         * value of entity held.
         * @param entityId
         * @param tagId
         */
        public getBranchNet(entityId: number, tagId: number): number {            
            var self = this;

            // TODO: Add method so that we don't need to rely on internals of TagBreakoutHelper.
            if (this._tagBreakoutHelper._tagIdToGroupMap[tagId]) {
                var tagGroup = this._tagBreakoutHelper._tagIdToGroupMap[tagId];

                var tag = tagGroup.tag;

                var net = this.getNet(entityId, tagId);

                if (tag.childTags) {
                    $(tag.childTags).each(function (i, childTag: any) {
                        net += self.getBranchNet(entityId, childTag.id);
                    });
                }

                return net;
            }

            return 0;
        }


        public getBreakoutCategories() {
            return this._tagBreakoutHelper.getBreakoutCategories();
        }
    }

}